export default "__VITE_ASSET__C10cYkhZ__"